import React, { Component } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import AddItems from "../AddItems/AddItems";
import ItemsBody from "../ItemsBody/ItemsBody";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class ItemsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items,
      rowsPerPage: 10,
      page: 0,
      itemData: {
        itemName: "",
        quantity: 0,
        rate: 0,
        purchasedFrom: "",
        purchasedDate: "",
      },
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      itemData: { ...this.state.itemData, [e.target.name]: e.target.value },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleEditData = (data) => {
    this.setState({
      itemData: {
        itemName: data.itemName,
        quantity: data.quantity,
        rate: data.rate,
        purchasedFrom: data.purchasedFrom,
        purchasedDate: data.purchasedDate,
      },
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      const response = await Axios.post(
        `${url}/api/item-categories/${this.props.categoryId}`,
        this.state.itemData,
        {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        }
      );
      if (response.data.itemCategoryId) {
        this.setState({
          itemData: {
            itemName: "",
            quantity: 0,
            rate: 0,
            purchasedFrom: "",
            purchasedDate: "",
          },
          loading: false,
        });
        this.props.getCategoryDetails(this.props.categoryId);
      }
    } catch (error) {
      this.setState({ loading: true });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  render() {
    const { rowsPerPage, page } = this.state;
    return (
      <TableContainer>
        <Table>
          <CustomTableHead column={this.props.column} />

          <TableBody>
            <AddItems
              loading={this.state.loading}
              itemData={this.state.itemData}
              handleChange={this.handleChange}
              handleSubmit={this.handleSubmit}
            />
            {this.props.items.length !== 0 &&
              this.props.items.map((item, index) => (
                <ItemsBody
                  data={item}
                  key={index}
                  index={index}
                  categoryId={this.props.categoryId}
                  getCategoryDetails={this.props.getCategoryDetails}
                  itemData={this.state.itemData}
                  handleEditData={this.handleEditData}
                  handleChange={this.handleChange}
                  handleSubmit={this.handleSubmit}
                />
              ))}
          </TableBody>

          <CustomTableFooter
            count={this.state.items.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={this.handlePage}
            onChangeRowsPerPage={this.handleRowsPerPage}
          />
        </Table>
      </TableContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ItemsForm));
